export default __webpack_public_path__ + "static/media/cancer11.0ce01d40.jpg";